import { render, staticRenderFns } from "./add-brand.vue?vue&type=template&id=7898b8d4&"
import script from "./add-brand.vue?vue&type=script&lang=js&"
export * from "./add-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports